/** Krabička pastelek. Jména se ukážou při výběru – děti si je rády čtou. */
export const PALETTE: { name: string; hex: string }[] = [
  { name: 'Citronová', hex: '#f7d842' },
  { name: 'Slunečnicová', hex: '#f2a541' },
  { name: 'Pomerančová', hex: '#f28a3b' },
  { name: 'Rumělková', hex: '#e0582f' },
  { name: 'Jahodová', hex: '#d93a4a' },
  { name: 'Malinová', hex: '#c2407e' },
  { name: 'Růžová', hex: '#f4a6c0' },
  { name: 'Levandulová', hex: '#a88fd0' },
  { name: 'Švestková', hex: '#6b4c9a' },
  { name: 'Nebeská', hex: '#7fbfe6' },
  { name: 'Modrá', hex: '#2f6db5' },
  { name: 'Tyrkysová', hex: '#2ba7a0' },
  { name: 'Hrášková', hex: '#9ccc5a' },
  { name: 'Trávová', hex: '#5aa33a' },
  { name: 'Lesní', hex: '#2f7d4a' },
  { name: 'Pleťová', hex: '#f3c7a6' },
  { name: 'Oříšková', hex: '#a0673a' },
  { name: 'Čokoládová', hex: '#5c3a24' },
  { name: 'Šedá', hex: '#9a9591' },
  { name: 'Uhlová', hex: '#2e2a27' },
  { name: 'Bílá', hex: '#ffffff' },
];
